import { NgModule } from '@angular/core';
import { NkQuickPanelComponent } from './quick-panel.component';
@NgModule({
  imports: [
    NkQuickPanelComponent
  ],
  exports: [NkQuickPanelComponent],
})
export class NkQuickPanelModule {}
